import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { MenuSelectorField, ModelAutocompleteField, ModelMenuSelectorField, OptionSelectorField } from '@front/squirtle'
import UserUtils from '@front/volcanion/utils/user'

const Row1 = ({ resetRecivers }) =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <OptionSelectorField
        name='audience'
        options={[
          { label: I18n.t('driver.label.all'), value: 'all' },
          { label: I18n.t('driver.label', { count: 1 }), value: 'custom_drivers' },
        ]}
        afterChange={resetRecivers}
      />
    </Grid>
  </Grid>

const Row2 = ({ audience, disableOptions }) =>
  <Grid container spacing={1} size={12}>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelMenuSelectorField
        name='vehicle_options'
        label={I18n.t('options.vehicleoption.label', { count: -1 })}
        model_name='vehicleoption'
        labelKeys={['name_translated']}
        searchMode='search'
        config={{
          initial_filter: {}
        }}
        multiple
        disabled={disableOptions}
      />
    </Grid>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelMenuSelectorField
        name='driver_options'
        label={I18n.t('options.useroption.label', { count: -1 })}
        model_name='useroption'
        labelKeys={['name_translated']}
        searchMode='search'
        config={{
          initial_filter: {}
        }}
        multiple
        disabled={disableOptions}
      />
    </Grid>
    <Grid hidden={audience !== 'all'} size="grow">
      <MenuSelectorField
        label={I18n.t('vehicle.pairing_type')}
        name='is_paired'
        noneLabel={I18n.t('all')}
        options={[
          { label: I18n.t('broadcast.paired'), value: true },
          { label: I18n.t('broadcast.not_paired'), value: false }
        ]}
        disabled={disableOptions}
      />
    </Grid>
    <Grid hidden={audience === 'all'} size="grow">
      <ModelAutocompleteField
        name={'drivers'}
        model_name={'user'}
        searchMode='search'
        searchQuery={'='}
        autocompleteMutator={q => ({
          or: [
            { info: { user_client_id: { startsWith: _.split(q, ' ') } } },
            { info: { first_name: { startsWith: _.split(q, ' ') } } },
            { info: { last_name: { startsWith: _.split(q, ' ') } } }]
        })}
        labelKeys={['label']}
        multiple
        loadOnFocus
        config={{
          forced_filter: { driverinfo: { '!': null } },
          populate: ['info', 'customerinfo'],
          mutator: user => ({
            label: UserUtils.getFormatedName({ ...user?.info, designation: user?.customerinfo?.name }, { prefix: user?.info?.user_client_id }),
            ...user
          })
        }}
        required={audience !== 'all'}
      />
    </Grid>
  </Grid>

const Row3 = ({ audience, disableOptions }) =>
  <Grid container spacing={1} size={12}>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelAutocompleteField
        name={'cities'}
        label={I18n.t('city.label', { count: 2 })}
        searchQuery={'contains'}
        autocompleteKey={'name'}
        model_name={'city'}
        searchMode={'search'}
        labelKeys={['name_translated']}
        config={{
          initial_filter: {},
          sortBy: ['name_translated'],
          sortDirection: ['asc']
        }}
        multiple
        disabled={disableOptions}
      />
    </Grid>
    <Grid hidden={audience !== 'all'} size="grow">
      <ModelMenuSelectorField
        name={'billing_category'}
        label={I18n.t('contract.category')}
        noneLabel={I18n.t('all')}
        noneValue={null}
        model_name={'billingcategory'}
        searchMode={'search'}
        labelKeys={['name_translated']}
        config={{ initial_filter: {} }}
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='vehicletypes'
        label={I18n.t('vehicletype.label', { count: -1 })}
        model_name='vehicletype'
        labelKeys={['name_translated']}
        searchMode='search'
        config={{
          initial_filter: {}
        }}
        multiple
        noneFirst
        noneLabel={I18n.t('all')}
        disabled={disableOptions}
      />
    </Grid>
  </Grid>

const AudienceSection = ({ disableOptions, ...rest }) => <>
  <StepLabel>
    <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 'h6.fontSize', color: 'text.title' }}>
      <Typography variant='h5'>{I18n.t('message.recipients')}</Typography>
    </Box>
  </StepLabel>
  <StepContent>
    <Box sx={{ boxShadow: 6, borderRadius: 1, p: 2 }}>
      <Grid container rowSpacing={2}>
        {!disableOptions && <Row1 {...rest} />}
        <Row2 {...rest} disableOptions={disableOptions} />
        <Row3 {...rest} disableOptions={disableOptions} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(AudienceSection)
